import {makeStyles, Theme} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    boxSizing: "border-box",
    backgroundColor: "#F8FAFC",
    padding: "16px",
    maxWidth: 1440,
    margin: "0 auto",
    width: "100%",
    [theme.breakpoints?.up("sm")]: {
      padding: "24px",
    },
  },

  wrapper: {
    backgroundColor: "#F8FAFC",
    padding: 12,
    borderRadius: 16,
    width: "100%",
    margin: "0 auto",
    height: "100%",
    [theme.breakpoints?.up("sm")]: {
      padding: 25,
      width: "95%",
    },
  },
  content_info: {
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(135deg, #0F172A 0%, #1E3A8A 50%, #2563EB 100%)",
    boxShadow: "0 14px 36px -4px rgba(37, 99, 235, 0.35)",
    borderRadius: 20,
    padding: "20px 24px",
    color: "#FFFFFF",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 22px 45px -8px rgba(37, 99, 235, 0.45)",
      borderColor: "rgba(255, 255, 255, 0.3)",
    },
    [theme.breakpoints?.up("sm")]: {
      flexGrow: 1,
    },
  },
  welcomeGlowTop: {
    position: "absolute",
    top: -50,
    right: -50,
    width: 180,
    height: 180,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(253, 224, 71, 0.25) 0%, rgba(253, 224, 71, 0) 70%)",
    pointerEvents: "none",
  },
  welcomeGlowBottom: {
    position: "absolute",
    bottom: -60,
    left: -40,
    width: 200,
    height: 200,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(59, 130, 246, 0.3) 0%, rgba(59, 130, 246, 0) 70%)",
    pointerEvents: "none",
  },
  welcomeSubtitle: {
    color: "#FDE047",
    fontWeight: 700,
    fontSize: "0.8rem",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    marginBottom: 2,
    textShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },
  welcomeTitle: {
    color: "#FFFFFF",
    fontWeight: 800,
    fontSize: "1.5rem",
    letterSpacing: "-0.02em",
    lineHeight: 1.1,
  },
  greetingBadge: {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.25)",
    borderRadius: 20,
    padding: "6px 14px",
    color: "#FFFFFF",
    fontSize: "0.825rem",
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  avatarWrapper: {
    position: "relative",
    flexShrink: 0,
  },
  avatarImage: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    objectFit: "cover",
    border: "3px solid #FDE047",
    boxShadow: "0 6px 18px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#FFFFFF",
  },
  onlineStatusDot: {
    position: "absolute",
    bottom: 2,
    right: 2,
    width: 14,
    height: 14,
    borderRadius: "50%",
    backgroundColor: "#10BCA7",
    border: "2px solid #0F172A",
    boxShadow: "0 0 8px #10BCA7",
  },
  userNameText: {
    fontWeight: 800,
    color: "#FFFFFF",
    fontSize: "1.15rem",
    lineHeight: 1.2,
    textShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },
  staffIdChip: {
    display: "inline-block",
    backgroundColor: "rgba(253, 224, 71, 0.2)",
    border: "1px solid rgba(253, 224, 71, 0.4)",
    color: "#FDE047",
    fontSize: "0.725rem",
    fontWeight: 700,
    borderRadius: 6,
    padding: "2px 8px",
    marginTop: 4,
  },
  userEmailText: {
    color: "#E2E8F0",
    fontSize: "0.8rem",
    marginTop: 2,
    fontWeight: 400,
    opacity: 0.9,
  },
  medalWrapper: {
    flexShrink: 0,
  },
  cardFooterAction: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 12,
    borderTop: "1px solid rgba(255, 255, 255, 0.15)",
  },
  viewProfileBtn: {
    color: "#FFFFFF",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(8px)",
    border: "1px solid rgba(255, 255, 255, 0.25)",
    borderRadius: 10,
    padding: "6px 16px",
    fontSize: "0.825rem",
    fontWeight: 700,
    textTransform: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#FFFFFF",
      color: "#1E3A8A",
      boxShadow: "0 4px 14px rgba(255, 255, 255, 0.4)",
    },
  },
  content__info__left: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  content__info__left__title: {
    color: "#FDE047",
    fontWeight: 800,
    fontSize: "0.75rem",
    textAlign: "center",
    padding: "4px 0 8px 0",
    letterSpacing: "-0.01em",
    textShadow: "0 2px 4px rgba(0,0,0,0.15)",
    [theme.breakpoints?.up("sm")]: {
      fontSize: "0.9rem",
      padding: "12px 0",
    },
    [theme.breakpoints?.up("lg")]: {
      fontSize: "1.1rem",
    },
  },

  content__info__avatar: {
    width: "100%",
    maxHeight: 110,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& >img": {
      maxWidth: "100%",
      maxHeight: 90,
      height: "auto",
      objectFit: "cover",
      borderRadius: 12,
      border: "2px solid #FFFFFF",
      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
    },
    [theme.breakpoints?.up("sm")]: {
      maxHeight: "none",
      height: "95%",
      "& >img": {
        maxHeight: "none",
        height: "100%",
      },
    },
  },
  content__info__no__avatar: {
    flexGrow: 1,
    border: "2px solid #FDE047",
    width: "100%",
    borderRadius: 12,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints?.down("md")]: {
      marginBottom: 10,
    },
    "& > div > img": {
      maxWidth: "90%",
      height: "auto",
      display: "block",
      margin: "auto",
      objectFit: "cover",
      borderRadius: 10,
    },
  },
  popup__message: {
    position: "relative",
    padding: 20,
    "&>div>img": {
      width: "90%",
      height: 40,
      position: "absolute",
      bottom: 0,
    },
  },
  hello_text: {
    position: "relative",
    "& >h5": {
      position: "absolute",
      bottom: 3,
      left: 6,
      width: "100%",
      color: "#004673",
      fontSize: 10,
      fontWeight: 700,
      lineHeight: "20px",
      zIndex: 99,
      [theme.breakpoints?.up("sm")]: {
        fontSize: 13,
        bottom: 7,
        left: 13,
        lineHeight: "25px",
      },
      [theme.breakpoints?.up("xl")]: {
        left: 15,
        bottom: 10,
        fontSize: 16,
      },
    },
    "& > img": {
      width: 90,
      [theme.breakpoints?.up("sm")]: {
        width: 130,
      },
      [theme.breakpoints?.up("xl")]: {
        width: 150,
      },
    },
  },
  medal: {
    width: 45,
    height: 45,
    filter: "drop-shadow(0 4px 10px rgba(0, 0, 0, 0.2))",
    [theme.breakpoints?.up("sm")]: {
      width: 90,
      height: 90,
    },
    [theme.breakpoints?.up("xl")]: {
      width: 120,
      height: 120,
    },
  },

  content__info__right: {
    padding: "8px 5px 0px 5px",
    borderTop: "1px solid rgba(255, 255, 255, 0.25)",
    color: "#FFFFFF",
    [theme.breakpoints?.up("sm")]: {
      padding: "15px 5px 0px 15px",
    },
    "& >h5": {
      fontWeight: 700,
      textTransform: "uppercase",
      color: "#FFFFFF",
      fontSize: "0.85rem",
      [theme.breakpoints?.up("sm")]: {
        fontSize: "1rem",
      },
      [theme.breakpoints?.up("xl")]: {
        fontSize: "1.2rem",
      },
    },
    "& >p": {
      color: "#E0F2FE",
      fontSize: "0.7rem",
      paddingTop: 2,
      fontWeight: 500,
      wordBreak: "break-all",
      [theme.breakpoints?.up("sm")]: {
        fontSize: "0.85rem",
        paddingTop: 4,
      },
    },
    "& >h6": {
      color: "rgba(255, 255, 255, 0.85)",
      fontSize: "0.7rem",
      paddingTop: 2,
      [theme.breakpoints?.up("sm")]: {
        fontSize: "0.85rem",
        paddingTop: 0,
      },
      [theme.breakpoints?.up("xl")]: {
        fontSize: "1rem",
      },
    },
  },
  content__info__right__name: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "4px",
    "& >h5": {
      fontSize: "0.85rem",
      fontWeight: 700,
      color: "#FFFFFF",
      wordBreak: "break-word",
      [theme.breakpoints?.up("sm")]: {
        fontSize: "1.1rem",
      },
      [theme.breakpoints?.up("xl")]: {
        fontSize: "1.4rem",
      },
    },
  },
  content__info__right__button: {
    background: "rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    border: "1px solid rgba(255, 255, 255, 0.4)",
    color: "#ffffff",
    borderRadius: 10,
    padding: "6px 14px",
    fontSize: 12,
    fontWeight: 600,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textTransform: "none",
    transition: "all 0.25s ease",
    "& .MuiButton-endIcon": {
      marginLeft: 5,
    },
    "&:hover": {
      background: "rgba(255, 255, 255, 0.35)",
      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
    },
    [theme.breakpoints?.up("sm")]: {
      padding: "6px 14px",
      fontSize: 12,
    },
  },
  content__lessonOfMonth: {
    background: "#FFFFFF",
    boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.03)",
    border: "1px solid #E2E8F0",
    borderRadius: 20,
    overflow: "hidden",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 18px 36px -6px rgba(217, 119, 6, 0.18)",
      borderColor: "#FDE68A",
    },
    [theme.breakpoints?.up("sm")]: {
      flexGrow: 1,
    },
  },
  content__lessonOfMonth__wrapper: {
    padding: "16px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    [theme.breakpoints?.up("sm")]: {
      padding: "16px 20px",
    },
    [theme.breakpoints?.up("xl")]: {
      padding: "20px 40px",
    },
  },
  content__lessonOfMonth__point: {
    color: "#D97706",
    fontSize: "2.4rem",
    fontWeight: 800,
    lineHeight: 1.1,
    "& > span": {
      color: "#94A3B8",
      fontSize: "1.2rem",
      fontWeight: 600,
      marginLeft: 4,
    },
  },
  content__lessonOfMonth__button: {
    background: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
    color: "#ffffff",
    borderRadius: 10,
    padding: "6px 18px",
    marginTop: 12,
    fontSize: 13,
    fontWeight: 700,
    boxShadow: "0 4px 14px rgba(217, 119, 6, 0.3)",
    textTransform: "none",
    transition: "all 0.25s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #B45309 0%, #D97706 100%)",
      boxShadow: "0 6px 18px rgba(217, 119, 6, 0.45)",
    },
  },
  content__lessonOfMonth__text: {
    fontSize: "0.8rem",
    color: "#64748B",
    textAlign: "center",
    padding: "8px 16px 12px 16px",
    fontWeight: 500,
    [theme.breakpoints?.up("xl")]: {
      fontSize: "0.875rem",
      padding: "12px 20px",
    },
  },
  content__lessonOfYear: {
    background: "#FFFFFF",
    boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.03)",
    border: "1px solid #E2E8F0",
    borderRadius: 20,
    overflow: "hidden",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 18px 36px -6px rgba(79, 70, 229, 0.18)",
      borderColor: "#C7D2FE",
    },
    [theme.breakpoints?.up("sm")]: {
      height: "100%",
    },
  },
  cardHeaderTitleRow: {
    background: "#FFFFFF",
    borderBottom: "1px solid #F1F5F9",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 20px",
  },
  content__lessonOfYear__point: {
    color: "#4F46E5",
    fontSize: "2.4rem",
    fontWeight: 800,
    lineHeight: 1.1,
    "& > span": {
      color: "#94A3B8",
      fontSize: "1.2rem",
      fontWeight: 600,
      marginLeft: 4,
    },
  },
  content__lessonOfYear__button: {
    background: "linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)",
    color: "#ffffff",
    borderRadius: 10,
    padding: "6px 18px",
    marginTop: 12,
    fontSize: 13,
    fontWeight: 700,
    boxShadow: "0 4px 14px rgba(79, 70, 229, 0.3)",
    textTransform: "none",
    transition: "all 0.25s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #4338CA 0%, #4F46E5 100%)",
      boxShadow: "0 6px 18px rgba(79, 70, 229, 0.45)",
    },
  },
  cardFooterNote: {
    background: "#F8FAFC",
    borderTop: "1px solid #F1F5F9",
    padding: "10px 16px",
  },

  rankingCard: {
    padding: "20px",
    background: "#FFFFFF",
    boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.03)",
    border: "1px solid #E2E8F0",
    borderRadius: 20,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    height: "100%",
    boxSizing: "border-box",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 18px 36px -6px rgba(30, 27, 75, 0.12)",
    },
    [theme.breakpoints?.down("sm")]: {
      padding: "14px",
    },
  },
  rankingTitle: {
    color: "#FDE047",
    textAlign: "left",
    fontWeight: 800,
    fontSize: "0.85rem",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    margin: 0,
  },
  ranking__content: {
    padding: "20px",
    background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 60%, #312E81 100%)",
    borderRadius: 16,
    color: "#FFFFFF",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.3)",
  },
  ranking__content__detail: {
    textAlign: "left",
    margin: "8px 0 16px 0",
  },
  rankLabelText: {
    fontSize: "0.7rem",
    fontWeight: 700,
    color: "rgba(255, 255, 255, 0.65)",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    marginBottom: 4,
  },
  highlightRankNum: {
    color: "#FDE047",
    fontSize: "3.2rem",
    fontWeight: 900,
    lineHeight: 1.05,
    letterSpacing: "-0.02em",
    textShadow: "0 4px 12px rgba(253, 224, 71, 0.25)",
  },
  totalStudentsText: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "0.825rem",
    fontWeight: 600,
    marginTop: 6,
  },
  rankSubtext: {
    color: "#E0E7FF",
    fontSize: "0.825rem",
    fontWeight: 500,
    marginTop: 8,
  },
  rankSubMetricsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 8,
    backgroundColor: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(6px)",
    borderRadius: 12,
    padding: "10px 12px",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    marginBottom: 14,
  },
  rankSubMetricItem: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
  },
  rankSubMetricLabel: {
    fontSize: "0.65rem",
    fontWeight: 700,
    color: "rgba(255, 255, 255, 0.6)",
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  rankSubMetricVal: {
    fontSize: "1rem",
    fontWeight: 800,
    color: "#FFFFFF",
    marginTop: 2,
  },
  rankFooterBadge: {
    display: "flex",
    alignItems: "center",
    color: "#34D399",
    fontSize: "0.775rem",
    fontWeight: 700,
    paddingTop: 10,
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
  },
  ranking__content__detail__increase: {
    color: "#79D66A",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    "& >svg": {
      fontSize: 17,
    },
    "& >span": {
      color: "#000",
      marginLeft: 5,
      fontSize: 12,
    },
  },
  liquid: {
    "& > div ": {
      fontSize: 10,
    },
  },
}));

export default useStyles;
